export const REFETCH_BLOCKS = 1
